import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ChannelsResourcesPage = loadAsyncComponent(() => import('./Container'), 'page');
